import { service } from '@ember/service';

import $ from 'jquery';

import type { Service } from 'webapp-types';
import { getGradient } from 'webapp/utils/color';

import type { OptionTransformed } from 'webapp/components/form/select';
import FormSelectWithActionComponent from 'webapp/components/form/select-with-action';

export default class FormSelectBoardComponent extends FormSelectWithActionComponent {
	@service('constants') declare constantsService: Service.Constants;

	override formatResult(item: OptionTransformed<string>, isOnList = false) {
		const result = super.formatResult(item, isOnList);

		if (result) {
			const avatarWrapper = result.find('.avatar-wrapper'),
				image = avatarWrapper.find('img'),
				count = parseInt(result.find('.label2').text(), 10);

			if (image && image.length > 0) {
				const gradientColor = getGradient(item.color!, this.constantsService.boardColors);
				result.find('img').attr('style', gradientColor);
			}

			if (count) {
				$(`<span class="count">${count}</span>`).appendTo(avatarWrapper);
			}
		}

		return result;
	}
}
